
import * as actions from './actions';
import { GET_WORKPLACE_SUCCESS, WORKPLACE_OVERVIEW_SET_INIT_STATE } from '../actions';
import update from 'react/lib/update';

export const initState = {
	text: null,
	active: false,
	pics: [{}, {}],
	activeBigPic: {
		isVisible: false,
		index: null
	},
	form: {
		active: false,
		isSubmitting: false
	}
}

export default (state = initState, action) => {
	switch (action.type) {
		case actions.SET_REDUCER_STATE:
			return update(state, {
				[action.key]: {
					$set: { ...state[action.key], ...action.val }
				}
			});
		case actions.ACTIVATE_FORM:
			return update(state, {
				form: {
					active: {
						$set: action.val
					}
				},
				activeBigPic: {
					isVisible: {
						$set: false
					}
				}
			});
		case actions.SAVE_DESCRIPTION_REQUEST:
			return update(state, {
				form: {
					isSubmitting: {
						$set: true
					}
				}
			});
		case actions.SAVE_DESCRIPTION_SUCCESS:
			return update(state, {
				text: {
					$set: action.text
				},
				form: {
					isSubmitting: {
						$set: false
					},
					active: {
						$set: false
					}
				}
			});
		case actions.SAVE_DESCRIPTION_FAILURE:
			return update(state, {
				form: {
					isSubmitting: {
						$set: false
					}
				}
			});
		case actions.SET_PICTURE:
			return update(state, {
				pics: {
					[action.index]: {
						$set: action.pic
					}
				}
			});
		case GET_WORKPLACE_SUCCESS:
			return update(state, {
				text: {
					$set: action.workplace.description
				}
			});
		case WORKPLACE_OVERVIEW_SET_INIT_STATE:
			return update(state, {
				$set: initState
			});
		case 'KILL_WORKPLACE':
			return initState
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Overview/description/reducer.js